const SectionTitle = () => import("@/components/SectionTitle/SectionTitle.vue");
const MissionsSearchForm = () => import("@/components/MissionDetail/MissionDetail.vue");
const ScheduleWishesForm = () => import("@/components/ScheduleWishesForm/ScheduleWishesForm.vue");
const spinner = () => import("@/components/Spinner/Spinner.vue");
const Datepicker = () => import("vuejs-datepicker/dist/vuejs-datepicker");
const MessagePopup = () => import("@/layouts/MessagePopupLayout/MessagePopupLayout.vue");

import { MESSAGE_POPUP } from "@/constants/candidateMenu";
import { USER_TYPE } from "../../constants/home";
import profileService from "@/services/profile";
import generalSettingService from "@/services/generalSetting";
import profileCandidateService from "@/services/profileCandidate";
import validateSMS from "@/mixins/validateSMS";
import Utils from "@/mixins/Utils";
import getProfileDictionary from "@/mixins/getProfileDictionary";

import "vue-croppa/dist/vue-croppa.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import PhoneInput from "@/components/Common/PhoneInput";
import { mapActions, mapGetters } from "vuex";
import { CIVILITE } from "../../constants/inscription";
import documentService from '@/services/document';
import { COMPONENT_KEYWORD, SCREEN_NAME } from "@/constants/variables";
import { analytics } from "@/services/firebase";
var moment = require("moment");
const nodeEnv =  window.configs && window.configs.NODE_ENV !== "" 
? window.configs.NODE_ENV: process.env.NODE_ENV;
export default {
  components: {
    Datepicker,
    SectionTitle,
    MissionsSearchForm,
    ScheduleWishesForm,
    spinner,
    PhoneInput,
    MessagePopup
  },
  mixins: [validateSMS, Utils, getProfileDictionary],
  data: () => ({
    isReadyInputSMSConfirmationCode: false,
    isConfirmedCodeSuccess: false,
    isVerifiedPhoneNumber: false,
    uploadedPhoto: [],
    base_email: "",
    isAddress: true,
    user: {
      pkAdv: 20190712000028,
      email: null,
      password: null,
      password_confirmation: null,
      name: null,
      firstName: null,
      address: null,
      zipcode: null,
      city: null,
      tel: null,
      photo: "",
      pkIxAdvProfiles: null,
      pkIxGender: null,
      pkIxCountriesIso3166Nationality: null,
      pkIxCountriesIso3166Born: null,
      pkIxCountriesIso3166: null,
      meansTransportCar: false,
      meansTransportMoto: false,
      meansTransportBike: false,
      meansTransportPermisB: false,
      meansTransportOtherComment: "",
      meansTransportPublicTransport: false,
      meansTransportPublicTransportComment: "",

      residencePermitNumber: null,
      residencePermitDateValidityBegin: null,
      residencePermitDateValidityEnd: null,
      registerAnpeDate: null,
      assedic: false,
      rmi: false,

      pkIxCurrentWork: null,
      reconnaissanceCotorep: null,
      reconnaissanceCotorepCategorie: null,
      reconnaissanceCotorepDateLimite: null,

      medicalRestrictionsComment: null,
      numberSecuritySocial: null,
      pkIxMaritalStatus: null,
      numberChildsAge: null,

      experiences: [],
      formations: [],
    },

    days: [
      {
        key: "monday_",
        name: "Lundi",
        morning: false,
        afternoon: false,
        evening: false,
      },
      {
        key: "tuesday_",
        name: "Mardi",
        morning: false,
        afternoon: true,
        evening: false,
      },
      {
        key: "wednesday_",
        name: "Mercredi",
        morning: false,
        afternoon: false,
        evening: false,
      },
      {
        key: "thursday_",
        name: "Jeudi",
        morning: false,
        afternoon: false,
        evening: false,
      },
      {
        key: "friday_",
        name: "Vendredi",
        morning: false,
        afternoon: false,
        evening: false,
      },
      {
        key: "saturday_",
        name: "Samedi",
        morning: false,
        afternoon: false,
        evening: false,
      },
      {
        key: "sunday_",
        name: "Dimanche",
        morning: false,
        afternoon: false,
        evening: false,
      },
    ],
    emptyExperience: {
      startDate: "",
      endDate: "",
      title: "",
      mission: "",
      pkIxAdvExperienceType: false,
      employer: "",
    },
    experience: [
      {
        startDate: "",
        endDate: "",
        title: "",
        mission: "",
        pkIxAdvExperienceType: false,
        employer: "",
        add: true,
      },
    ],
    formation: {
      diplomaYear: "",
      diplomaTitle: "",
      // add: true,
    },

    situation: [],

    advProfiles: [
      { pkIxAdvProfiles: 1, advProfile: "Auxiliaire de vie" },
      { pkIxAdvProfiles: 2, advProfile: "Assistant(e) de vie" },
      { pkIxAdvProfiles: 3, advProfile: "Aide ménager(e)" },
      { pkIxAdvProfiles: 4, advProfile: "Art thérapeute" },
    ],
    countries: [],
    spinner_variable: {
      spinnerConnexionInfo: false,
      spinnerPersonalInfo: false,
      spinnerExperience: false,
      spinnerFormation: false,
      spinnerTransport: false,
      spinnerMounted: false,
      spinnerAdministrative: false,
      spinnerPlanning: false,
    },
    error: "",
    showAlert: false,
    myCroppa: {},
    tempPhoto: "",
    validatedPhoto: false,
    errorMessage: "",
    hidden: nodeEnv !== 'development',
    maxSizeUploadImage: 0,
    showPassword: false,
    showConfirmPassword: false,
    isUpdateSuccess: false,
    isUpdateFailed:false,
    refuseImgUrl:'',
    confirmImgUrl:''
  }),

  computed: {
    ...mapGetters('profile', ['profileInfo', 'fullProfileInfo']),
    messagePopupType() {
      return MESSAGE_POPUP.TYPE;
    },
    passwordLengthValid() {
      return (this.user.password || '').length >= 8;
    },
    passwordUppercaseValid() {
      return /[A-Z]/.test(this.user.password);
    },
    passwordNumberValid() {
      return /\d/.test(this.user.password);
    },
    passwordSpecialValid() {
      return /[^A-Za-z0-9]/.test(this.user.password);
    },
    allPasswordValid() {
      return (
        this.passwordLengthValid &&
        this.passwordUppercaseValid &&
        this.passwordNumberValid &&
        this.passwordSpecialValid
      );
    },
    passwordsMatch() {
      return this.user.password === this.user.password_confirmation;
    },
    userType() {
      return USER_TYPE.CANDIDATE;
    },
    civilite() {
      return CIVILITE;
    },
    userInfo() {
      return JSON.parse(localStorage.getItem('user'));
   },
   isExAdv () {
    return this.userInfo.isEmployee && this.userInfo.applicationStatus === 13;
   } ,
  },
  async created() {
    this.trackScreen(SCREEN_NAME.PROFILE_INFOS_LOGIN, platform);
    this.getGeneralSetting();
    this.getRefuseImage();
    this.getConfirmImage();
    await this.getSituation();
  },
  mounted() {
    this.getChargePlanning();
    this.getProfileTypes();
    this.getCountries();
    //PK_CRF_ADV
  },
  methods: {
    ...mapActions('profile', ['getProfileInfo']),
    hideModalSMSValidation() {
      this.$refs["validationSMS"].hide();
    },
    hideModalChangeConnexionInfo() {
      this.$refs["validationChangeConnexionInfo"].hide();
    },
    getGeneralSetting() {
      generalSettingService.getGeneralSetting().then((res) => {
        if(res.success && res.configuration) {
          const config = res.configuration;
          this.maxSizeUploadImage = config.maxSizeUploadImage;
        }
      })
    },
    previewImage: function(event) {
      // Reference to the DOM input element

      const vue = this;

      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        const size = (input.files[0].size) / 1024 / 1024;

        if(size > this.maxSizeUploadImage) {
          this.callToaster(this.$t('upload-file-max-size-alert').replace('[fileSize]', this.maxSizeUploadImage));
          return;
        }

        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          vue.tempPhoto = e.target.result;
          vue.validatedPhoto = false;
          vue.user.photo = "";
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    getRefuseImage() {
      documentService.getComponentBykeyword({keyword:COMPONENT_KEYWORD.REFUSED_IMAGE_WEB}).then((res)=> {
         if(res && res.components) {
          this.refuseImgUrl = res.components && res.components.length > 0 ? res.components.find(component => component.appName === '2').urlFile : '';

         }
      })
   },
   getConfirmImage() {
      documentService.getComponentBykeyword({keyword:COMPONENT_KEYWORD.CONFIRMATION_REQUEST_IMAGE_WEB}).then((res)=> {
         if(res && res.components) {
          this.confirmImgUrl = res.components && res.components.length > 0 ? res.components.find(component => component.appName === '2').urlFile : '';

         }
      })
   },
    showModalSMSValidation() {
      const vue = this;

      this.isAllowedToRegister().then(function(results) {
        vue.$refs["validationSMS"].show();
      });
    },
    isValidPhonenumber() {
      return this.$validator.validate("numéro de téléphone", this.user.tel);
    },
    isAllowedToRegister() {
      // Logical work around warning !! x)
      // Créer un PK pour l'adv avec un email pour pouvoir valider son numéro de téléphone
      const vue = this;
      return new Promise(function(resolve, reject) {
        vue.isValidPhonenumber().then(function(results) {
          if (results) {
            resolve("Go ahead and do your thing");
          } else {
            reject("Phonenumber invalid");
          }
        });
      });
    },

    handleAfterGetInfo(response) {
      this.spinner_variable.spinnerMounted = false;
      this.user = response.data;
      this.base_email = this.user.email;
      this.user.full_address =
        this.user.address + ", " + this.user.zipcode + ", " + this.user.city;
      this.user.registerAnpeDate =
        this.user.registerAnpeDate === null
          ? null
          : moment(this.user.registerAnpeDate).format("YYYY-MM-DD");
      this.user.reconnaissanceCotorepDateLimite =
        this.user.reconnaissanceCotorepDateLimite === null
          ? null
          : moment(this.user.reconnaissanceCotorepDateLimite).format(
          "YYYY-MM-DD"
          );
      this.user.residencePermitDateValidityBegin =
        this.user.residencePermitDateValidityBegin === null
          ? null
          : moment(this.user.residencePermitDateValidityBegin).format(
          "YYYY-MM-DD"
          );
      this.user.residencePermitDateValidityEnd =
        this.user.residencePermitDateValidityEnd === null
          ? null
          : moment(this.user.residencePermitDateValidityEnd).format(
          "YYYY-MM-DD"
          );
      for (var i = 0; i < this.user.experiences.length; i++) {
        this.user.experiences[i].startDate =
          this.user.experiences[i].startDate === null
            ? null
            : moment(this.user.experiences[i].startDate).format(
            "YYYY-MM-DD"
            );
        this.user.experiences[i].endDate =
          this.user.experiences[i].endDate === null
            ? null
            : moment(this.user.experiences[i].endDate).format(
            "YYYY-MM-DD"
            );
      }
      this.days = response.listAvailability;
      this.experience = this.user.experiences;
      this.formation = this.user.formations;
      if (this.user.experiences.length <= 0) {
        this.user.experiences.push(Object.assign({}, this.emptyExperience));
      }
    },

    getSituation() {
      profileService.getSituation().then((res) => {
        const material = res.data;

        material.forEach((item) => {
          item.value = item.pkIxMaritalStatus;
          item.text = item.maritalStatus;
        });

        this.situation = material;
      }).catch((err) => {
        this.showAlert = true;
        this.errorMessage = this.$t("error-try-again");
      });
    },

    getChargePlanning() {
      const vue = this;
      vue.spinner_variable.spinnerMounted = true;
      this.getProfileInfo()
        .then((response) => {
          this.handleAfterGetInfo(response);
        })
        .catch((error) => {
          vue.showAlert = true;
          vue.errorMessage = vue.$t("error-try-again");
        })
        .finally(function() {
          vue.spinner_variable.spinnerMounted = false;
        });
    },
    submitPersonalInfo: function() {
      const vue = this;
      var err = this.$validator.errors;
      this.$validator.validateAll().then((result) => {
        if (
          !vue.checkErrors(err, [
            "nouvelle-adresse",
            "nom",
            "prénom",
            "nationalité",
            "pays de naissance",
            "numéro de téléphone",
            "civilité",
          ])
        ) {
          (vue.spinner_variable.spinnerPersonalInfo = true),
            profileService
              .updateInfor({
                pkAdv: vue.user.pkAdv,
                name: vue.user.name,
                firstName: vue.user.firstName,
                tel: vue.user.tel,
                city: vue.user.city,
                address: vue.user.address,
                zipcode: vue.user.zipcode,
                pkIxCountriesIso3166Nationality:
                vue.user.pkIxCountriesIso3166Nationality,
                pkIxCountriesIso3166Born: vue.user.pkIxCountriesIso3166Born,
                pkIxCountriesIso3166: vue.user.pkIxCountriesIso3166,
                photo: vue.user.photo,
                pkIxAdvProfiles: vue.user.pkIxAdvProfiles,
                pkIxGender: vue.user.pkIxGender,
                lng: vue.user.lng,
                lat: vue.user.lat,
              })
              .then(function(response) {
                (vue.spinner_variable.spinnerPersonalInfo = false),
                  (vue.output = response.success);
                vue.callToaster(vue.$t("modification-saved"));
              })
              .catch(function(error) {
                (vue.spinner_variable.spinnerPersonalInfo = false),
                  (vue.output = error);
              });
        }
      });
    },
    trackScreen(screenName) {
      analytics.logEvent("screen_view", {
        screen_name: screenName,
        platform: 'web'
      });
    },
    submitConnexionInfo: function(confirm) {
      const vue = this;
     
      vue.isUpdateFailed= true;
      vue.isUpdateSuccess=false;
      vue.spinner_variable.spinnerConnexionInfo = false;

      profileCandidateService
        .updateConnectionInfo({
          pkAdv: vue.user.pkAdv,
          email: vue.user.email,
          password: vue.user.password,

        }, { isLogged: true,
          source:2})
        .then((response) => {
          vue.spinner_variable.spinnerConnexionInfo = false;
          vue.$refs['validationConnectionModal'].show();
          if (response.success) {
            this.trackScreen(SCREEN_NAME.PASSWORD_MODIFIED);

            vue.isUpdateSuccess = true;
            vue.output = response.message;
            // vue.callToaster(vue.$t("modification-saved"));
          } else {
            this.trackScreen(SCREEN_NAME.AN_ERROR_OCCURRED);
            vue.isUpdateFailed = true;
            vue.output = response.message;
            // vue.callToaster(
            //   vue.$t('error-occur')+": " + response.message
            // );
          }
        })
        .catch((error) => {
          vue.$refs['validationConnectionModal'].show();
          vue.isUpdateFailed = true;
          vue.spinner_variable.spinnerConnexionInfo = false;
          vue.output = error;
          this.trackScreen(SCREEN_NAME.AN_ERROR_OCCURRED);
        })
        .finally(() => {
          vue.user.password = "";
          vue.user.password_confirmation = "";
        });
    },
   
    submitTransports: function() {
      const vue = this;
      vue.spinner_variable.spinnerTransport = true;
      profileService
        .updateTransport({
          pkAdv: vue.user.pkAdv,
          meansTransportCar: vue.user.meansTransportCar,
          meansTransportMoto: vue.user.meansTransportMoto,
          meansTransportBike: vue.user.meansTransportBike,
          meansTransportPublicTransport: vue.user.meansTransportPublicTransport,
          meansTransportPublicTransportComment:
          vue.user.meansTransportPublicTransportComment,
          meansTransportOtherComment: vue.user.meansTransportOtherComment,
          meansTransportPermisB: vue.user.meansTransportPermisB,
        })
        .then((response) => {
          vue.spinner_variable.spinnerTransport = false;
          vue.output = response.data;
          vue.callToaster(vue.$t('modification-saved'));
        })
        .catch((error) => {
          vue.spinner_variable.spinnerTransport = false;
          vue.output = error;
        });
    },
    submitAdminInfo: function() {
      const vue = this;
      vue.spinner_variable.spinnerAdministrative = true;
      profileService
        .updateAdminInfor({
          pkAdv: vue.user.pkAdv,
          residencePermitNumber: vue.user.residencePermitNumber,
          residencePermitDateValidityBegin:
          vue.user.residencePermitDateValidityBegin,
          residencePermitDateValidityEnd:
          vue.user.residencePermitDateValidityEnd,
          registerAnpeDate: vue.user.registerAnpeDate,
          assedic: vue.user.assedic,
          rmi: vue.user.rmi,
          pkIxCurrentWork: vue.user.pkIxCurrentWork,
          reconnaissanceCotorep: vue.user.reconnaissanceCotorep,
          reconnaissanceCotorepCategorie:
          vue.user.reconnaissanceCotorepCategorie,
          reconnaissanceCotorepDateLimite:
          vue.user.reconnaissanceCotorepDateLimite,
          medicalRestrictionsComment: vue.user.medicalRestrictionsComment,
          numberSecuritySocial: vue.user.numberSecuritySocial,
          pkIxMaritalStatus: vue.user.pkIxMaritalStatus,
          numberChildsAge: vue.user.numberChildsAge,
        })
        .then(function(response) {
          vue.spinner_variable.spinnerAdministrative = false;
          vue.output = response.data;
          vue.callToaster(vue.$t('modification-saved'));
        })
        .catch(function(error) {
          vue.spinner_variable.spinnerAdministrative = false;
          vue.output = error;
        });
    },
    validateExperiences() {
      const invalid = this.user.experiences.filter((userExperience) => {
        return (
          !userExperience.startDate ||
          !userExperience.endDate ||
          userExperience.startDate > userExperience.endDate
        );
      });
      console.log(invalid);
      if (invalid.length > 0) return false;
      return true;
    },
    submitExperiences: function() {
      const vue = this;
      vue.spinner_variable.spinnerExperience = true;

      if (!this.checkExperience()) {
        vue.spinner_variable.spinnerExperience = false;
        return;
      }
      var exp = [];
      vue.user.experiences.forEach((e) => {
        var newexp = Object.assign({}, e);
        delete newexp.add;
        newexp.pkIxAdvExperienceType = newexp.pkIxAdvExperienceType ? 1 : 0;
        exp.push(newexp);
      });
      profileService
        .updateExp({
          pkAdv: vue.user.pkAdv,
          experiences: exp,
        })
        .then(function(response) {
          (vue.spinner_variable.spinnerExperience = false),
            (vue.output = response.data);
          vue.callToaster(vue.$t('modification-saved'));
        })
        .catch(function(error) {
          (vue.spinner_variable.spinnerExperience = false),
            (vue.output = error);
        });
    },

    submitFormations: function() {
      const vue = this;
      let formations= [];
      vue.spinner_variable.spinnerFormation = true;
      if (!vue.checkFormation()) {
        vue.spinner_variable.spinnerFormation = false;
        return;
      }

      // for (var i = 0; i < vue.formation.length; i++) {
      //   if (!vue.user.formations.includes(vue.formation[i])) {
      //     vue.deleteFormation(vue.formation[i]);
      //   }
      // }

      vue.user.formations.forEach(e => {
        formations.push({ diplomaYear: e.diplomaYear || '', diplomaTitle: e.diplomaTitle, })
      })

      profileService
        .updateTraining({
          pkAdv: vue.user.pkAdv,
          formations,
        })
        .then(function(response) {
          (vue.spinner_variable.spinnerFormation = false),
            (vue.output = response.data.message);
          vue.callToaster(vue.$t('modification-saved'));
        })
        .catch(function(error) {
          console.error(error);
          (vue.spinner_variable.spinnerFormation = false), (vue.output = error);
        });
    },
    addExperience() {
      this.user.experiences.push(Object.assign({}, this.emptyExperience));
    },
    checkExperience() {
      var ret = true;
      const vue = this;
      vue.user.experiences.forEach((element) => {
        if (
          element.endDate === "" ||
          element.startDate === "" ||
          element.employer === "" ||
          element.title === "" ||
          element.mission === ""
        ) {
          ret = false;
        }
      });
      if (
        vue.user.experiences.length === 1 &&
        vue.user.experiences[0].endDate === "" &&
        vue.user.experiences[0].startDate === "" &&
        vue.user.experiences[0].employer === "" &&
        vue.user.experiences[0].title === "" &&
        vue.user.experiences[0].mission === ""
      ) {
        ret = true;
      }
      if (!ret) {
        vue.callToaster(
          vue.$t('fill-out-all-field-experience')
        );
      }
      return ret;
    },
    deleteExperience(i) {
      this.user.experiences.splice(i, 1);
      if (this.user.experiences.length <= 0) {
        this.user.experiences.push(Object.assign({}, this.emptyExperience));
      }
    },
    checkFormation() {
      const vue = this;
      let ret = true;
      let diplomaYear = null;
      let diplomaTitle = null;
      let validFormations = {};
      if (vue.user.formations.length) {
        vue.user.formations.forEach((element) => {
          if (vue.user.formations.length === 1) {
            diplomaYear = element.diplomaYear || null;
            diplomaTitle = element.diplomaTitle || null;
          }
          if (!/^([0-9]{4})$/.test(element.diplomaYear) && element.diplomaYear) {
            validFormations.diplomaYear = element.diplomaYear;
          } else {
            validFormations.diplomaYear = null;
          }
          if (element.diplomaTitle) {
            validFormations.diplomaTitle = element.diplomaTitle;
          } else {
            validFormations.diplomaTitle = null;
          }
        });
        if (vue.user.formations.length === 1 && !diplomaYear && !diplomaTitle) {
          ret = true;
        } else {
          if (validFormations.diplomaYear !== null) {
            vue.callToaster(vue.$t('year-not-valid').replace("${arg}", validFormations.diplomaYear));
            ret = false;
          }
          if (!validFormations.diplomaTitle) {
            vue.callToaster(vue.$t('formation-title-required'));
            ret = false;
          }
        }
      }
      return ret;
    },
    addFormation() {
      // if (
      //   this.formation.diplomaYear === "" ||
      //   this.formation.diplomaTitle === ""
      // ) {
      //   this.callToaster(this.$t('empty-formation'));
      //   return;
      // }

      this.user.formations.push(Object.assign({}, this.formation));
      // this.formation = {
      //   diplomaYear: "",
      //   diplomaTitle: "",
      //   add: true,
      // };
    },

    deleteFormation(event) {
      const vue = this;
      profileCandidateService
        .deleteFormation({
          pkAdvDiploma: event.pkAdvDiploma,
        })
        .then(function(response) {
          vue.user.formations.splice(i, 1);
        })
        .catch(function(error) {
          (vue.spinner_variable.spinnerFormation = false), (vue.output = error);
        });
    },

    changeAddress($event) {
      const value = $event.target.value;
      return this.isAddress = value !== this.user.full_address;
    },

    setAddress(place) {
      if (place.formatted_address) {
        let route,
          postal_code,
          locality,
          street_number = "";
        for (const component of place.address_components) {
          if (!street_number && component.types.indexOf("street_number") > -1)
            street_number = component.long_name;
          else if ((!locality && component.types.indexOf("locality") > -1) ||
              (!locality && component.types.indexOf("sublocality") > -1))
            locality = component.long_name;
          else if (!postal_code && component.types.indexOf("postal_code") > -1)
            postal_code = component.long_name;
          else if (!route && component.types.indexOf("route") > -1)
            route = component.long_name;
        }
        this.isAddress = true;
        this.user.address = street_number + " " + route;
        this.user.zipcode = postal_code;
        this.user.city = locality;
        this.user.full_address = this.user.address + ", " + this.user.zipcode + ", " + this.user.city;
        (this.user.lat = place.geometry.location.lat()),
          (this.user.lng = place.geometry.location.lng());
      }
    },

    usePlace(place) {
      if (this.user.address) {
        var newPostion = {
          lat: this.user.address.geometry.location.lat(),
          lng: this.user.address.geometry.location.lng(),
        };
        this.user.address = newPostion;
      }
    },
    checkErrors(errors, fieldArray) {
      for (const field of fieldArray) {
        if (errors.has(field)) {
          if (
            field != "nouvelle-adresse" ||
            !this.user.zipcode ||
            !this.user.address ||
            !this.user.city || !this.isAddress
          )
            return true;
        }
      }
      return false;
    },
    validationPhoto() {
      const vue = this;
      vue.myCroppa.generateBlob(
        (blob) => {
          var reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = function() {
            vue.validatedPhoto = true;
            vue.user.photo = reader.result;
            return;
          };
        },
        "image/jpeg",
        0.8
      ); // 80% compressed jpeg file
    },
    handleImageRemove() {
      this.tempPhoto = null;
      this.user.photo = "";
      this.uploadedPhoto = [];
      this.validatedPhoto = false;
    },
    sendConfirmationCode() {
      const vue = this;
      vue.sendSMS(vue.user.tel);
    },
  },
};
